import type { RouteRecordRaw } from 'vue-router'
import { i18n } from '@/shared/i18n'

export const StorePages = {
  list: 'ListStore',
}

const { t } = i18n.global

export const ListStore: RouteRecordRaw = {
  path: '',
  name: StorePages.list,
  component: () => import('@/pages/mainPageWithRoute/store/ListStorePage.vue'),
  meta: { title: t('pages.listStore'), requiresAuth: true },
}

export const Stores: RouteRecordRaw = {
  path: '/store',
  name: 'Stores',
  component: () => import('@/pages/mainPageWithRoute/MainPageWithRouterView.vue'),
  meta: { title: t('pages.listStore'), requiresAuth: true },
  children: [ListStore],
}
